import React, { useCallback, useEffect, useState } from "react";
import BaseButton from "components/BaseButton";
import BaseIcon from "components/BaseIcon";
import "./style.scss";

type BannerStatus = "downloading" | "ready" | "error";

export default function DesktopUpdateBanner() {
  const [version, setVersion] = useState<string | null>(null);
  const [status, setStatus] = useState<BannerStatus>("downloading");
  const [percent, setPercent] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const api = window.smeet;
    if (!api?.updater) return;

    const unsubs: Array<() => void> = [];

    unsubs.push(
      api.updater.onUpdateAvailable((info) => {
        console.log("[UpdateBanner] available:", info.version);
        setVersion(info.version);
        setStatus("downloading");
        setPercent(0);
      })
    );

    unsubs.push(
      api.updater.onUpdateProgress((p) => {
        setPercent(Math.round(p.percent));
      })
    );

    unsubs.push(
      api.updater.onUpdateDownloaded((info) => {
        console.log("[UpdateBanner] downloaded:", info.version);
        setVersion(info.version);
        setStatus("ready");
      })
    );

    unsubs.push(
      api.on("update:error", (err: any) => {
        console.error("[UpdateBanner] error:", err);
        setStatus("error");
      })
    );

    return () => unsubs.forEach((u) => u());
  }, []);

  const handleRestart = useCallback(() => {
    window.smeet?.updater.installUpdate();
  }, []);

  const handleDismiss = useCallback(() => {
    setDismissed(true);
  }, []);

  if (!version || dismissed) return null;

  const text =
    status === "ready"
      ? `Обновление v${version} загружено. Перезапустите приложение.`
      : status === "error"
      ? `Ошибка загрузки обновления v${version}.`
      : `Загрузка обновления v${version}… ${percent > 0 ? `${percent}%` : ""}`;

  return (
    <div className={`desktop-update-banner ${status === "error" ? "desktop-update-banner--error" : ""}`}>
      <div className="desktop-update-banner__container container">
        <div className="desktop-update-banner__inner">
          <div className="desktop-update-banner__text">{text}</div>
          {status === "ready" && (
            <BaseButton className="desktop-update-banner__btn" live onClick={handleRestart}>
              Перезапустить
            </BaseButton>
          )}
          <BaseButton className="desktop-update-banner__close-btn" icon small onClick={handleDismiss}>
            <BaseIcon>close</BaseIcon>
          </BaseButton>
        </div>
      </div>
    </div>
  );
}
